import { CollaboratorPermission } from '../../api';

const translation = {
	// common words
	'common.login': 'Log In',
	'common.SignUp': 'Sign Up',
	'common.logout': 'Log Out',
	'common.version': 'Version',
	'common.settings': 'Account Settings',
	'common.cancel': 'Cancel',
	'common.NA': 'N/A',
	'common.True': 'True',
	'common.Reset': 'Reset',
	'common.Edit': 'Edit',
	'common.Create': 'Create',
	'common.Delete': 'Delete',
	'common.Update': 'Update',
	'common.Upload': 'Upload',
	'common.welcome': 'Welcome',
	'common.Success': 'Success',
	'common.Save': 'Save',
	'common.Website': 'Website',
	'common.Configure': 'Configure',
	'common.Image': 'Image',
	'common.Video': 'Video',
	'common.Submit': 'Submit',
	'common.SaveChanges': 'Save Changes',
	'common.Discard': 'Discard',
	'common.InvalidForm': 'The form is invalid.',
	'common.Reveal': 'Reveal',
	'common.Get': 'Get',
	'common.Success.assetUpload': '{{assetType}} Successfully Uploaded',
	'common.Success.assetUpload.description': "You successfully uploaded a {{assetType}} to {{projectName}}'s Project Assets.",
	'common.noSpaces': '{{fieldName}} cannot contain spaces',
	'common.unsafeCharacters': '{{fieldName}} cannot contain unsafe characters (?, ;, :, /, &, =).',
	'api.defaultError': 'It’s not you, it’s us. Please refresh the page.',
	'form.confirmation.title': 'Save Changes',
	'form.confirmation.content': 'Do you want to save changes before leaving this page?',
	'form.confirmation.errorMessage.title': 'Cannot save changes.',
	'form.confirmation.errorMessage.description':
		'Required fields are missing values. Complete the required fields and save changes.',
	'modal.confirmation.content': 'Are you sure you want to close the pop-up?',
	'form.confirmation.okText': 'Yes',
	'notification.error.title': 'Something went wrong.',
	common: {
		filter: 'Filter',
		exportCsv: 'Export to CSV',
		currency: ' ${{val}}',
		statistic: '{{val}}',
		exportAsPdf: 'Export as PDF',
		confirm: {
			cancel: 'No, Cancel',
			delete: 'Yes, Delete',
		},
	},
	// common words

	// tables
	'table.showTotal': '{{range0}}-{{range1}} of {{count}} item',
	'table.showTotal_other': '{{range0}}-{{range1}} of {{count}} items',
	'table.noResults': 'No results matching your search',
	'table.noData': 'No Data',
	// tables

	// common validation
	'validation.required': '{{fieldName}} is required',
	'validation.requiredPlural': '{{fieldName}} are required',
	'validation.positive': '{{fieldName}} must be positive',
	'validation.moreThan': '{{fieldName}} must be more than {{num}}',
	'validation.maxLength': '{{fieldName}} should be {{count}} characters maximum',
	'validation.minLength': '{{fieldName}} should be {{count}} characters minimum',
	'validation.maxNumber': 'Maximum {{fieldName}} is {{count}}',
	'validation.integer': 'Please enter a valid number',
	'validation.min': '{{fieldName}} must have at least {{min}} item(s)',
	'validation.email': '{{errValue}} must be a valid email',
	validation: {
		moreThanOrEqual: '{{fieldName}} must be more than {{value}}',
		cantBeZero: "{{fieldName}} can't be zero",
	},
	// common validation

	// sider
	'sider.AllProjects': '< All Projects',
	'sider.ProjectList': 'Project List',
	'sider.Collaborators': 'Collaborators',
	'sider.StoreDetails': 'Store Details',
	'sider.Builds': 'Builds',
	'sider.GameServices': 'Game Services',
	'sider.Finance': 'Finance',
	'sider.Players': 'Players',
	'sider.Analytics': 'Analytics',
	'sider.RedemptionCodes': 'Redemption Codes',
	// sider

	// ProductStatus enum
	'ProductStatus.Draft': 'Draft',
	'ProductStatus.Released': 'Released',
	'ProductStatus.SubmittedForReview': 'Submitted for Review',
	'ProductStatus.Rejected': 'Rejected',
	'ProductStatus.AwaitingChanges': 'Awaiting Changes',
	'ProductStatus.ApprovedForStore': 'Approved for Store',
	'ProductStatus.ApprovedForWorkshop': 'Approved for Workshop',
	'ProductStatus.InReview': 'In Review',
	'ProductStatus.ChangesSubmitted': 'Changes Submitted',
	// ProductStatus enum

	// invitation
	'invitation.expired': 'The invitation link has expired. Contact your project administrator.',
	// invitation

	// pages
	'InitialSetupPage.Header': 'Welcome to the Omniverse!',
	'InitialSetupPage.FormHeader': "Let's get to know you",
	'InitialSetupPage.firstName': 'First Name',
	'InitialSetupPage.lastName': 'Last Name',
	'InitialSetupPage.Username': 'Username',
	'InitialSetupPage.SaveAndContinue': 'Save & Continue',
	'InitialSetupPage.Save': 'Save',
	'InitialSetupPage.DateOfBirth': 'Date of Birth',
	'InitialSetupPage.Country': 'Country',
	'InitialSetupPage.form.Success.title': 'Thank you!',
	'InitialSetupPage.form.Success': 'Your personal information has been successfully updated.',
	'InitialSetupPage.UsernameLengthRequirement': '2-15 characters',
	'InitialSetupPage.CharacterRequirement': 'Only numbers, letters, dashes, underscores',
	'InitialSetupPage.ConsecutiveDashes': 'No consecutive dashes or underscores',
	'InitialSetupPage.StartEndRequirement': 'Must start and end with a letter or number',
	'ProjectSetupPage.Name': 'Project Name',
	'ProjectSetupPage.Button': 'Create Project',
	'ProjectSetupPage.Button.JoinProject': 'Join Project',
	'ProjectSetupPage.Description': "Let's get you started. Give your project a name.",
	'ProjectSetupPage.Description.SingleInvitation': '{{inviterName}} is waiting for you to join {{projectName}}.',
	'ProjectSetupPage.Description.MultiInvitation': 'You have been invited to join multiple Omni One developer projects.',
	'ProjectSetupPage.Switch.CreateProjectView': 'or create your own project',
	'ProjectSetupPage.Switch.AcceptInvitationView': 'or view your invitations',
	'ProjectSetupPage.MultiInvitation.Dropdown': '{{projectName}} invited by {{inviterName}}',
	'ProjectSetupPage.MultiInvitation.SelectPlaceholder': 'Select an invitation',
	'EmailVerificationPage.Header': 'Check your email!',
	'EmailVerificationPage.EmailSentToMessage': 'We just sent an email to ',
	'EmailVerificationPage.ResendSuccess': "We've just resent the confirmation email to your email address.",
	'EmailVerificationPage.Instruction': 'Click the link in the email to verify your account and log in.',
	'EmailVerificationPage.ReturnToLogin': 'Return to Log In',
	'EmailVerificationPage.ResendMessage': "Didn't receive the email? Check your spam folder, or ",
	'EmailVerificationPage.ResendLink': 'resend email',
	'TermsAndConditionsPage.AcceptAndContinue': 'Accept & Continue',
	'ProjectsPage.Header': 'My Projects',
	'ProjectsPage.InputPlaceholder': 'What is the name of your project?',
	'ProjectPage.Notification.Header': 'New Project Created',
	'ProjectPage.Notification.Message': 'You successfully created {{project_name}}.',
	'ProjectsPage.Invitations': 'Project Invitations ({{count}})',
	'ProjectPage.Invitation.Body': 'Invited by {{inviter_name}}',
	'ProjectPage.Invitation.Decline': 'Decline Invitation',
	'ProjectPage.Invitation.Accept': 'Join Project',
	'ProjectPage.Sorter.SortBy': 'Sort by',
	'ProjectPage.Sorter.NewestToOldest': 'Newest to Oldest',
	'ProjectPage.Sorter.OldestToNewest': 'Oldest to Newest',
	'ProjectPage.Sorter.AToZ': 'A-Z',
	'ProjectPage.Sorter.ZToA': 'Z-A',
	'ProjectPage.Created': 'Created',
	'ProjectPage.Delete.Confirmation.Title': 'Delete Project',
	'ProjectPage.Delete.Confirmation.Description': 'Are you sure you want to delete this project?',
	'ProjectPage.Delete.Success.Title': 'Project Deleted',
	'ProjectPage.Delete.Success.Description': 'You successfully deleted {{name}}.',
	analyticsPage: {
		header: `Analytics`,
		activeUsers: 'Number of players in the last 90 days',
		gameplayHours: 'Hours Played',
		averageSession: 'Average Playtime per Session',
		minute: 'Minute',
		minutes: 'Minutes',
		hour: 'Hour',
		hours: 'Hours',
		day: 'Day',
		days: 'Days',
		minutePlayed: '$t(analyticsPage.minute) $t(analyticsPage.played)',
		minutesPlayed: '$t(analyticsPage.minutes) $t(analyticsPage.played)',
		hourPlayed: '$t(analyticsPage.hour) $t(analyticsPage.played)',
		hoursPlayed: '$t(analyticsPage.hours) $t(analyticsPage.played)',
		dayPlayed: '$t(analyticsPage.day) $t(analyticsPage.played)',
		daysPlayed: '$t(analyticsPage.days) $t(analyticsPage.played)',
		played: 'Played',
		allTime: 'All-Time',
		userData: 'User Data',
		totalAllTimeSessions: 'Gameplay Sessions',
		totalAllTimeSteps: 'Steps',
		totalAllTimeCalories: 'Calories',
		totalAllTimeMiles: 'Miles',
		topTenActiveUsers: 'Top Ten Active Players',
		time: 'Total Hours',
		playTimeLine: 'Hours Played Over Time',
		sessions: 'Sessions',
		players: 'Players',
		monthly: 'Monthly',
		last30Days: 'Last 30 Days',
		daily: 'Daily',
		noData: "Your project doesn't have any data to display yet.",
		NotReleased: {
			line1: '$t(analyticsPage.noData)',
			line2: 'Check back after your game has been released to the Omni Store.',
		},
		ReleasedRecently: {
			line1: '$t(analyticsPage.noData)',
			line2: 'Check back after 24 hours to view updated analytics on your game.',
		},
	},
	'financePage.RevenueAnalytics': 'Revenue Analytics',
	'financePage.Payments': 'Payments',
	'financePage.AccountInfo': 'Bank Account',
	'financePage.Header': 'Finance',
	'financePage.GoToStoreDetails': 'Go to Store Details',
	'financePage.NoPaymentMethod': 'Set up your bank account to receive earnings from the Omni One store.',
	'financePage.NoPaymentMethod.zeroprice':
		'To receive earnings from the Omni One store, your product price must be greater than 0.00.<br/>Then return to this page to set up your bank account.',
	'financePage.ChangePaymentMethod': 'Change Payment Method',
	financePage: {
		SalesDetails: 'Sales Details',
		SalesDetailsTab: {
			Price: 'Selling Price',
			Revenue: 'Net Revenue',
			Code: 'Redemption Code',
			Purchaser: 'Purchaser',
			PurchaseTime: 'Time of Purchase',
		},
		PaymentsTab: {
			Month: 'Month',
			Amount: 'Amount',
			Status: 'Status',
			Download: 'Download Statement',
			inProcess: 'In Process',
			paid: 'Paid',
			accrued: 'Accrued',
		},
		RevenueAnalyticsTab: {
			MonthToDate: 'Month-to-Date ({{date}})',
			CopiesSold: 'Copies Sold',
			Date: 'Date',
			Revenue: 'Revenue',
			EarnedRevenue: 'Earned Revenue',
			Last30DaysRevenue: 'Last 30 Days Revenue',
			Last12MonthsRevenue: 'Last 12 Months Revenue',
			NotReleased: {
				line1: 'Complete the steps for the review process to be approved for the Omni One store.',
			},
			NoRevenue: {
				line1: 'Congratulations on releasing on the Omni One store!',
				line2: 'Revenue analytics will appear once an initial sale has been made.',
			},
			GoToProject: 'Go to Project Steps',
		},
	},
	'playersPage.Header': 'Players',
	'playersPage.Tab.Users': 'Test Users',
	'playersPage.Tab.Users.Header.InvitePlayer': 'Invite Test Users',
	'testInvitationPage.loading': 'Your access is almost ready...',
	'testInvitationPage.finishedLoading': 'You can now playtest on Omni Dev.',
	'testInvitationPage.finishedLoading.subtitle':
		'Start playtesting on your Omni One headset by launching the game from the Library.',
	'testInvitationPage.error.accepted': 'The invitation has already been accepted.',
	'testInvitationPage.error.accepted.subtitle': 'Playtest on your Omni One headset by launching the game from the Library.',
	'testInvitationPage.error': 'Cannot retrieve invitation',
	'testInvitationPage.error.subtitle': 'Contact the developer that invited you for support.',
	'playersPage.Tab.Users.None.Line1': "Your project doesn't have any test users yet.",
	'playersPage.Tab.Users.None.Line2': 'Start building your community by clicking the "Invite a Test User" button.',
	'playersPage.Tab.Users.NoBuilds.Line1': 'You cannot invite test users to your project yet.',
	'playersPage.Tab.Users.NoBuilds.Line2': 'Go to the Builds page to upload a Beta build of your project first.',
	'playersPage.Tab.Users.NoProjectAssets.Line1': 'You cannot invite test users to your project yet.',
	'playersPage.Tab.Users.NoProjectAssets.Line2':
		'Go to the Store Details page to complete the project assets of your project first.',
	'playersPage.Tab.Users.NoBuilds.Button': 'View Builds',
	'playersPage.Tab.Users.NoProjectAssets.Button': 'View Project Assets',
	'playersPage.Tab.Users.NoAccess.Line1': 'You cannot invite test users to your project yet.',
	'playersPage.Tab.Users.NoAccess.Line2': '1. Reach out to your project administrator to issue access to the Builds page.',
	'playersPage.Tab.Users.NoAccess.Line3': '2. On the Builds page, upload a build of your project.',
	'playersPage.Tab.Users.NoAccess.Line4': '3. Return to this page to invite test users.',
	'playersPage.toolTip.disabledInviteButton': 'Go to the Builds page to upload a Beta build of your project first.',
	'playersPage.Tab.Users.Table.UserName': 'Username',
	'playersPage.Tab.Users.Table.UserEmail': 'Email Address',
	'playersPage.Tab.Users.Table.PermittedChannels': 'Permitted Release Channels',
	'playersPage.Tab.Users.Table.BetaChannel': 'Beta Channel',
	'playersPage.Tab.Users.Table.Delete': 'Delete',
	'playersPage.Tab.Users.DeleteTestUserModal.Header': 'Delete Test User',
	'playersPage.Tab.Users.DeleteTestUserModal.OkButton': 'Yes, Delete',
	'playersPage.Tab.Users.DeleteTestUserModal.Body': 'Are you sure you want to delete {{testUserName}}?',
	'playersPage.Tab.Users.DeleteTestUserModal.Success.Header': 'Test User Deleted',
	'playersPage.Tab.Users.DeleteTestUserModal.Success.Body': 'You successfully deleted the test user {{testUserName}}.',
	'playersPage.Tab.Users.InviteModal.Header': 'Invite Test Users',
	'playersPage.Tab.Users.InviteModal.Email': 'Test User Email Address(es)',
	'playersPage.Tab.Users.InviteModal.Email.hint': 'Split emails with commas or spaces',
	'playersPage.Tab.Users.InviteModal.OkButton': 'Send Invitation',
	'playersPage.Tab.Users.InviteModal.Success.Header': 'You successfully invited {{emails}} test users.',
	'playersPage.Tab.Users.InviteModal.Success.Body': 'Invitation was sent to {{emails}} test users.',
	'playersPage.Tab.Users.InviteModal.Info.Header': 'Invitations were not sent to {{count}} users.',
	'playersPage.Tab.Users.InviteModal.Info.Body': 'These users already exist as test users: {{usersList}}',
	'projectDetailsPage.Header': 'Store Details',
	'productDetailsPage.ProductDetails': 'Product Details',
	'productDetailsPage.ProductDetails.hint': 'Product information is visible in the store and gets used in searches.',
	'productDetailsPage.Status': 'Status',
	'productDetailsPage.Genre': 'Genre',
	'productDetailsPage.Language': 'Language',
	'productDetailsPage.ProductPrice': 'Product Price',
	'productDetailsPage.AgeRating': 'Age Rating',
	'productDetailsPage.MovementIntensity': 'Movement Intensity',
	'productDetailsPage.NumberOfPlayers': 'Number of Players',
	'productDetailsPage.Key': 'Key',
	'productDetailsPage.ProductFile': 'Product File',
	'productDetailsPage.FileInformation': 'File Information',
	'productDetailsPage.FileInformation.Size': 'Size',
	'productDetailsPage.Edit': 'Edit',
	'addProductPage.AddProduct': 'Add Product',
	'addProductPage.ProductDetails': 'Product Details',
	'addProductPage.ProductDetails.hint': 'Product information is visible in the store and gets used in searches.',
	'addProductPage.form.Name.Placeholder': 'Game name',
	'addProductPage.form.Developer.Placeholder': 'Developer name',
	'addProductPage.form.Publisher.Placeholder': 'Publisher name',
	'addProductPage.form.Description.Placeholder':
		'Provide a short description of your project for potential players to view in store.',
	'addProductPage.form.Name': 'Name',
	'addProductPage.form.Genre.Placeholder': 'Select applicable genres',
	'addProductPage.form.Genre.hint': 'Categories that describe the gameplay',
	'addProductPage.form.Language.Placeholder': 'Select supported languages',
	'addProductPage.form.Language.hint': '',
	'addProductPage.form.ProductName': 'Product Name',
	'addProductPage.form.Name.hint': 'Name of the game or application',
	'addProductPage.form.SupportedPlayStyles.hint': 'How does the player interact with the game?',
	'addProductPage.form.SupportedPlayStyles': 'Supported Play Styles',
	'addProductPage.form.Status': 'Status',
	'addProductPage.form.Status.hint': 'Status of the project',
	'addProductPage.form.Description': 'Description',
	'addProductPage.ProductAssets': 'Product Assets',
	'addProductPage.ProjectDetails': 'Project Details',
	'addProductPage.ProjectDetails.success.message': '{{type}} Saved',
	'addProductPage.ProjectDetails.success.description': "You successfully saved {{projectName}}'s {{type}}.",
	'addProductPage.ProjectAssets': 'Project Assets',
	'addProductPage.coverAssets': 'Cover Assets',
	'addProductPage.coverImage.hint1': 'Square - Used in mobile and launcher Library pages',
	'addProductPage.coverImage.hint2': '1:1 - 512x512px (png, jpeg, 2MB max)',
	'addProductPage.coverImage.hint3': '(png, jpeg, 2MB max)',
	'addProductPage.portraitImage.hint1': 'Portrait',
	'addProductPage.portraitImage.hint2': '7:10 - 1008 x 1440px (png, jpeg, 2MB max)',
	'addProductPage.portraitImage.hint3': '(png, jpeg, 2MB max)',
	'addProductPage.HeroImage': 'Hero Image',
	'addProductPage.heroImage.hint1': 'Hero Image Banner - Used in mobile and launcher Game Details pages',
	'addProductPage.heroImage.hint2': '10:3 - 1200x360px (png, jpeg, 2MB max)',
	'addProductPage.landscapeImage.hint1': 'Landscape - Used in mobile and launcher Store pages',
	'addProductPage.landscapeImage.hint2': '16:9 - 640x360px (png, jpeg, 2MB max)',
	'addProductPage.miniImage.hint1': 'Mini',
	'addProductPage.miniImage.hint2': '3:1 - 1080x360px (png, jpeg, 2MB max)',
	'addProductPage.iconImage': 'Icon',
	'addProductPage.iconImage.hint1': 'Icon (Used in mobile library)',
	'addProductPage.iconImage.hint2': '1:1 - 512x512px',
	'addProductPage.brandIconImage': 'Brand Icon',
	'addProductPage.brandIconImage.hint1': 'Logo (Used in recommendations)',
	'addProductPage.brandIconImage.hint2': '9000px width x 1440px height on background transparent',
	'addProductPage.screenshots': 'Screenshots',
	'addProductPage.screenshots.hint1': 'Screenshot {{screenshotNum}}',
	'addProductPage.screenshots.hint2': '16:9 - 1280x720px (png, jpeg, 2MB max)',
	'addProductPage.trailer': 'Trailer',
	'addProductPage.trailer.hint1': 'Trailer',
	'addProductPage.trailer.hint2': '16:9 - 1280 x 720px  - minimum size (png, jpeg, 2MB max)',
	'addProductPage.videos': 'Videos',
	'addProductPage.videos.optional': '(optional)',
	'addProductPage.videos.uploadButton': 'Upload Video File',
	'addProductPage.videos.hint1': 'Video {{screenshotNum}}',
	'addProductPage.videos.hint2': '16:9 - 1280x720px (100 MB Max Size)',
	'addProductPage.videos.uploadVideoFile': 'Upload Video File',
	'addProductPage.videos.trailer.hint1':
		'Video Trailer {{screenshotNum}} Cover - Used in mobile and launcher Game Details pages',
	'addProductPage.videos.trailer.hint2': '16:9 - 1280x720px (png, jpeg, 2MB max)',
	'addProductPage.newProductSuccess': '{{productName}} was successfully created.',
	'addProductPage.newProductSuccess.title': 'New product added.',
	'addProductPage.ProductFile': 'Product File',
	'addProductPage.ProductFile.hint': 'You can upload any number of files',
	'addProductPage.ProductFile.limit': 'Upload 1 APK file and any number of additional assets',
	'addProductPage.ProductFile.validation.OneApk': 'One APK file is required',
	'addProductPage.ProductFile.validation.OnlyOneApk': 'Only one APK file can be uploaded',
	'addProductPage.Genre': 'Genres',
	'addProductPage.Language': 'Languages',
	'addProductPage.AgeRating': 'Age Rating',
	'addProductPage.AgeRating.hint': 'Rating categories suggest age appropriateness',
	'addProductPage.MovementIntensity': 'Movement Intensity',
	'addProductPage.MovementIntensity.hint': 'How much movement does the game require?',
	'addProductPage.NumberOfPlayers': 'Number of Players',
	'addProductPage.PlayStyles.SinglePlayer': 'Single Player',
	'addProductPage.PlayStyles.OnlineCoop': 'Online Co-op',
	'addProductPage.PlayStyles.OnlinePvP': 'Online PvP',
	'addProductPage.PlayStyles.OnlineSocial': 'Online Social',
	'addProductPage.positiveNumber': 'Must be positive',
	'addProductPage.NumberOfPlayers.hint': 'How many people can play your game at once',
	'addProductPage.ProductPrice': 'Product Price',
	'addProductPage.ProductPrice.hint': 'Price as it appears on the Omni Online storefront',
	'addProductPage.ProductPrice.validation': 'Please enter a valid price',
	'addProductPage.Screenshots': 'Screenshots',
	'addProductPage.Screenshot1': 'Screenshot 1',
	'addProductPage.Screenshot2': 'Screenshot 2',
	'addProductPage.Screenshot3': 'Screenshot 3',
	'addProductPage.Screenshot4': 'Screenshot 4',
	'addProductPage.screenshot.hint1': '256x256px, 96x96px, 64x64px, 48x48px, 32x32px, 16x16px',
	'addProductPage.screenshot.hint2': '(png, jpeg, 2MB max)',
	'addProductPage.Landscapecoverimage': 'Landscape cover image',
	'addProductPage.Squarecoverimage': 'Square cover image',
	'addProductPage.Portraitcoverimage': 'Portrait cover image',
	'addProductPage.Minicoverimage': 'Mini cover image',
	'addProductPage.Bannerheroimage': 'Hero image banner',
	'addProductPage.Iconimage': 'Icon image',
	'addProductPage.BrandIconimage': 'Brand icon logo',
	'addProductPage.Videos': 'Videos',
	'addProductPage.Videos.optional': '(optional)',
	'addProductPage.Video1': 'Video 1',
	'addProductPage.Video1image': 'Video 1 image',
	'addProductPage.Video2': 'Video 2',
	'addProductPage.Video2image': 'Video 2 image',
	'addProductPage.video.hint1': '16:9 2560x1400',
	'addProductPage.video.hint2': '(30 MB Max Size)',
	'addProductPage.form.Publisher': 'Publisher',
	'addProductPage.form.Publisher.hint': 'Same as Developer',
	'addProductPage.form.Developer': 'Developer',
	'addProductPage.form.Developer.hint': 'Name of the developing studio',
	'addProductPage.form.MovementModes': 'Movement Modes',
	'addProductPage.form.MovementModes.hint': 'Select all that apply',
	'addProductPage.form.SameAsDeveloper': 'Same as Developer',
	'addProductPage.form.Website': '$t(common.Website) (optional)',
	'addProductPage.form.Website.hint': 'Website of the game or application',
	'uploader.fileTypeError': 'The file type is not supported, please select another file',
	'uploader.fileResolutionError': 'The maximum image resolution is {{width}} x {{height}} pixels, please select another file',
	'uploader.imageExactResolutionError':
		'The image resolution should be {{width}} x {{height}} pixels, please select another file',
	'uploader.videoExactResolutionError': 'The video resolution should be {{width}} x {{height}}, please select another file',
	'uploader.sizeError.MB': 'The maximum file size is {{fileSize}} MB, please select another file',
	'uploader.sizeError.GB': 'The maximum file size is {{fileSize}} GB, please select another file',
	'uploader.uploadError': 'Uploading error. Please try again.',
	'uploader.maxCountError': 'You can upload up to {{count}} files maximum',
	'uploader.maxCountError_plural': 'You can upload up to {{count}} files maximum',
	'uploader.dnd': 'Drag and drop files here to upload or browse files',
	'uploader.UploadFile': 'Upload File',
	'uploader.UploadVideoFile': 'Upload Video File',
	'uploader.UploadVideoImage': 'Upload Video Image',
	'projectSummaryPage.UpdateProjectName': 'Edit Project Name',
	'projectSummaryPage.UpdateProjectName.Success.Header': 'Project Name Updated',
	'projectSummaryPage.UpdateProjectName.Success.Body': 'You successfully updated project name {{name}}',
	'projectSummaryPage.UpdateProjectName.Checkbox.Label': 'Apply change to Store display name',
	'projectSummaryPage.sdkKey': 'Entitlement Key: {{sdkKey}}',
	'projectSummaryPage.productId': 'ProductId: ',
	'projectSummaryPage.userGameToken': 'UserGameToken: ',
	'projectSummaryPage.serverAccessKey': 'Server Access Key: ',
	'projectSummaryPage.Collaborators': 'Collaborators',
	'projectSummaryPage.Collaborators.subText': 'View and invite new collaborators to help complete your project.',
	'projectSummaryPage.StoreDetails': 'Store Details',
	'projectSummaryPage.StoreDetails.subText': 'Define how your project will be displayed in the Omni One store.',
	'projectSummaryPage.Builds': 'Builds',
	'projectSummaryPage.Builds.subText': 'Upload builds to various release channels to test your project.',
	'projectSummaryPage.GameServices': 'Game Services',
	'projectSummaryPage.GameServices.subText':
		'Enable and configure matchmaking, leaderboards, stats tracking, and achievements.',
	'projectSummaryPage.Finance': 'Finance',
	'projectSummaryPage.Finance.subText':
		'Set up your payment details, view your payment history, download monthly statements, and review revenue analytics.',
	'projectSummaryPage.Players': 'Players',
	'projectSummaryPage.Players.subText': 'Invite and manage test users, view player information.',
	'projectSummaryPage.Analytics': 'Analytics',
	'projectSummaryPage.Analytics.subText': 'Review performance data and gameplay analytics.',
	'projectSummaryPage.RedemptionCodes': 'Redemption Codes',
	'projectSummaryPage.RedemptionCodes.subText': 'Create and manage redemption codes for your project.',
	'projectSummaryPage.ProgressCard.header': 'To make your game available to Omni One players, complete the following steps:',
	'projectSummaryPage.ProgressCard.storeDetails': 'Add store details.',
	'projectSummaryPage.ProgressCard.paymentDetails': 'Configure your payment details (required only for paid product).',
	'projectSummaryPage.ProgressCard.publishingRequirements': 'Review and complete the Publishing Requirements.',
	'projectSummaryPage.ProgressCard.uploadBuild': 'Upload a Build to the RC Release Channel.',
	'projectSummaryPage.ProgressCard.submitProject': 'Submit your project for review.',
	'projectSummaryPage.ProgressCard.reject': 'Your project has been rejected.',
	'projectSummaryPage.ProgressCard.Approved': 'Approved!',
	'projectSummaryPage.ProgressCard.Released': 'Released!',
	'projectSummaryPage.ProgressCard.submitProject.confirmation.contentDescription':
		'Once the project has been submitted, you can no longer make changes to the Store Details and Builds pages unless changes are requested by the Virtuix review team.',
	'projectSummaryPage.ProgressCard.submitProject.confirmation.checkboxDescription': 'I agree to Virtuix’s ',
	'projectSummaryPage.ProgressCard.submitProject.confirmation.checkboxLink': 'Content Submission Terms',
	'projectSummaryPage.ProgressCard.submitProject.confirmation.contentEndline':
		'Are you sure you want to submit this project for review?',
	'projectSummaryPage.ProgressCard.submitProject.confirmation.okText': 'Yes, Submit Project',
	'projectSummaryPage.ProgressCard.submitProject.button.0': 'Submit for review',
	'projectSummaryPage.ProgressCard.submitProject.button.4': 'Submit for review',
	'projectSummaryPage.ProgressCard.submitProject.button.2': '$t(ProductStatus.SubmittedForReview)',
	'projectSummaryPage.ProgressCard.afterApproval': 'After Approval, publish your project to the Omni Store. 🎉',
	'projectSummaryPage.ProgressCard.publishToStore': 'Publish to the Omni Store',
	'projectSummaryPage.Submitted.Message': 'Project Submitted',
	'projectSummaryPage.Submitted.Description': 'You successfully submitted {{projectName}} for review.',
	'projectSummaryPage.Release.Confirmation.title': 'Publish to the Omni Store',
	'projectSummaryPage.Release.Confirmation.content': 'Are you sure you want to publish this project to the Omni Store?',
	'projectSummaryPage.Release.Confirmation.OK': 'Yes, Publish',
	'projectSummaryPage.Release.Message': 'Project Successfully Published to the Omni One Store',
	'projectSummaryPage.Release.Description': 'You successfully published {{projectName}} to the Omni One Store.',
	'projectBuildsPage.Header': 'Builds',
	'projectBuildsPage.Columns.ReleaseChannel': 'Release Channel',
	'projectBuildsPage.Columns.Name': 'Build Name',
	'projectBuildsPage.Columns.Version': 'Version',
	'projectBuildsPage.Columns.DateUpdated': 'Date Updated',
	'projectBuildsPage.Columns.TestUsers': 'Test Users',
	'projectBuildsPage.Columns.ReviewStatus': 'Review Status',
	'projectBuildsPage.Columns.Actions': 'Actions',
	'projectBuildsPage.UploadBuild': 'Upload Build',
	'projectBuildsPage.UpdateBuild': 'Update Build',
	'projectBuildsPage.UploadSuccess.Message': 'You successfully uploaded your build.',
	'projectBuildsPage.UploadSuccess.Description': 'The build has been added to the {{channel}} release channel.',
	'projectBuildsPage.UploadFailed.Message': 'Cannot upload package.',
	'projectBuildsPage.Actions.ReleaseOnStore': 'Release on Store',
	'projectBuildsPage.Actions.ReleaseOnStore.Message': 'Build Released on Store',
	'projectBuildsPage.Actions.ReleaseOnStore.Description': 'You successfully released {{buildName}} on store.',
	'projectBuildsPage.Actions.Edit': 'Edit Build Name',
	'projectBuildsPage.Actions.Edit.Message': 'Build Name Changed',
	'projectBuildsPage.Actions.Edit.Description': 'You successfully edited {{buildName}}.',
	'projectBuildsPage.Actions.Delete': 'Delete Build',
	'projectBuildsPage.Actions.Delete.Message': 'Build Deleted',
	'projectBuildsPage.Actions.Delete.Description': 'You successfully deleted {{buildName}}.',
	'projectBuildsPage.Actions.DeleteFail.Message': 'Cannot Delete Build',
	'projectBuildsPage.Actions.DeleteFail.Description':
		'You cannot delete "{{buildName}}" since it has been submitted for review',
	'projectBuildsPage.PublishingRequirements': 'View Publishing Requirements',
	'projectsBuildPage.Inputs.Name': 'Build Name',
	'projectsBuildPage.Inputs.UpdateType': 'Update Type',
	'projectsBuildPage.Inputs.UpdateType.Fix': 'Bug Fix',
	'projectsBuildPage.Inputs.UpdateType.Feature': 'New/Updated Content',
	'projectsBuildPage.Inputs.Required': 'Update Required',
	'projectsBuildPage.Inputs.Required.Hint': 'Is this a required or optional update?',
	'projectsBuildPage.Inputs.Required.Required': 'Required',
	'projectsBuildPage.Inputs.Required.Optional': 'Optional',
	'projectsBuildPage.Inputs.Channel': 'Select release channel',
	'projectsBuildPage.Inputs.Files': 'Build Files',
	'projectBuildsPage.Actions.Delete.Modal': 'Are you sure you want to delete this build?',
	'buildDetailsPage.Header': 'Release Channel Details',
	'buildDetailsPage.CardHeader': 'Current Build',
	'buildDetailsPage.details.id': 'Build ID',
	'buildDetailsPage.details.version': 'Version',
	'buildDetailsPage.details.created': 'Created Date',
	'buildDetailsPage.details.size': 'Size',
	'buildDetailsPage.details.versionCode': 'Version Code',
	'buildDetailsPage.details.fileName': 'Launch File',
	'buildDetailsPage.UpdateButton': 'Update Build',
	'buildDetailsPage.ReplacingConfirmation.Title': 'Replacing Build',
	'buildDetailsPage.ReplacingConfirmation.Body': 'Are you sure you want to replace your build?',
	'buildDetailsPage.ReplacingConfirmation.CancelButton': 'No, Cancel',
	'buildDetailsPage.ReplacingConfirmation.OkButton': 'Yes, Replace',
	'projectBuildsPage.PromoteToStore': 'Promote to STORE',
	'buildDetailsPage.details.obbFile': 'Assets',
	'collaboratorsPage.Header': 'Collaborators',
	'collaboratorsPage.Header.InviteCollaborator': 'Invite a Collaborator',
	'collaboratorsPage.collaboratorsTable.userName': 'Name',
	'collaboratorsPage.collaboratorsTable.userEmail': 'Email Address',
	'collaboratorsPage.collaboratorsTable.permissions': 'Permissions',
	'collaboratorsPage.collaboratorsTable.permissions.All': 'All (Project Administrator)',
	'collaboratorsPage.collaboratorsTable.email.pendingInvitation': 'Invitation Pending',
	'collaboratorsPage.collaboratorsTable.email.resend': 'Resend',
	'collaboratorsPage.collaboratorsTable.edit': 'Edit',
	'collaboratorsPage.collaboratorsTable.delete': 'Delete',
	'collaboratorsPage.DeleteCollaboratorModal.Header': 'Delete Collaborator',
	'collaboratorsPage.DeleteCollaboratorModal.OkButton': 'Yes, Delete',
	'collaboratorsPage.DeleteCollaboratorModal.Body': 'Are you sure you want to delete {{collaboratorName}}?',
	'collaboratorsPage.DeleteCollaboratorModal.Success.Header': 'Collaborator Deleted',
	'collaboratorsPage.DeleteCollaboratorModal.Success.Body': 'You successfully deleted {{collaboratorName}}.',
	'collaboratorsPage.EditCollaboratorModal.Header': 'Edit {{collaboratorName}}',
	'collaboratorsPage.EditCollaboratorModal.Body': 'Enabled Project Permissions',
	'collaboratorsPage.EditCollaboratorModal.Success.Header': 'Collaborator Updated',
	'collaboratorsPage.NoPermissionsError': 'Cannot save a collaborator with no permissions.',
	'collaboratorsPage.EditCollaboratorModal.Success.Body': 'You successfully updated the {{collaboratorName}}.',
	'collaboratorsPage.ReassignAdminModal.Body':
		'You must assign a new Project Administrator before you can complete removing permissions.' +
		'<br/><br/>To assign Project Administrator rights to a non-collaborator, you must <0>invite them to the project</0> first.<br/><br/>Assign Project Administrator',
	'collaboratorsPage.ReassignAdminModal.Header': 'Reassign Project Administrator',
	'collaboratorsPage.ReassignAdminModal.OkButton': 'Assign and Save',
	'collaboratorsPage.ReassignAdminModal.SelectPlaceholder': 'Select collaborator',
	'collaboratorsPage.InviteCollaboratorModal.Header': 'Invite a Collaborator',
	'collaboratorsPage.InviteCollaboratorModal.Email': 'Collaborator’s Email Address',
	'collaboratorsPage.InviteCollaboratorModal.Email.Placeholder': 'wow@email.com',
	'collaboratorsPage.InviteCollaboratorModal.Permissions': 'Enable Project Permissions',
	'collaboratorsPage.InviteCollaboratorModal.OkButton': 'Send Invitation',
	'collaboratorsPage.InviteCollaboratorModal.Form.Permissions': 'Project Permission',
	'collaboratorsPage.InviteCollaboratorModal.Success.Header': 'Collaborator Invitation Sent',
	'collaboratorsPage.InviteCollaboratorModal.Success.Body': 'Invitation was sent to {{emails}}.',
	'collaboratorsPage.InviteCollaboratorModal.Success.Description': 'Invitations were sent to {{emails}}.',
	'collaboratorsPage.InviteCollaboratorModal.Fail.Description': 'Invitations failed to send to {{email}}.',
	'collaboratorsPage.InviteCollaboratorModal.Email.IsAlreadyAdded':
		'You already invited {{email}}. Click the Resend button on the previous screen to reinvite.',
	gameServicesPage: {
		header: 'Game Services',
		achievements: {
			header: 'Achievements',
			subText: 'Define challenges and create awards to stimulate players to achieve goals.',
		},
		gameStats: {
			header: 'Game Stats',
			subText: 'Set player stats for competitive online multiplayer engagement.',
		},
		leaderboards: {
			header: 'Leaderboards',
			subText: 'Define a Leaderboard.',
		},
		downloadableContent: {
			header: 'Downloadable Content (DLC)',
			subText: 'Upload downloadable content for your project.',
		},
	},
	gameStatsPage: {
		header: 'Game Stats',
		create: 'Create Game Stat',
		columns: {
			apiName: 'API Name',
			title: 'Title',
			format: 'Format',
			unitOfMeasurement: 'Unit of Measurement',
			actions: 'Actions',
		},
		actions: {
			edit: 'Edit Game Stat',
			delete: 'Delete Game Stat',
			deleteMessage: 'Game Stat Deleted',
			deleteDescription: 'You successfully deleted {{apiName}}.',
			deleteModal: {
				header: 'Delete Game Stat',
				okButton: 'Yes, Delete',
				body: 'Are you sure you want to delete {{apiName}}?',
			},
			deleteWarningModal: {
				header: 'This game stat cannot be deleted.',
				cancelButton: 'Go to Leaderboards',
				okButton: 'Close',
				body: {
					p1: 'The following leaderboard(s) are currently using game stat {{apiName}}:',
					p2: 'The listed leaderboards must be assigned a different game stat before {{apiName}}can be deleted.',
				},
			},
		},
		emptyDataDescription: {
			line1: 'Your project does not have any game stats yet.',
			line2: 'Enable game stats by clicking the “Create Game Stat” button.',
		},
	},
	downloadableContent: {
		title: 'Downloadable Content (DLC)',
		subTitle:
			'Set up content that can be purchased for your application. This content can be made available either through In-App Purchases or as downloadable content (DLC).',
		add: 'Add DLC',
		table: {
			actions: 'Actions',
			searchInput: {
				placeHolder: 'Search SKU',
				confirm: 'Search',
			},
			columns: {
				name: 'Name',
				sku: 'SKU',
				type: 'Type',
				publishedIn: 'Published In',
				price: 'Price',
				dateCreated: 'Date Created',
				status: 'Status',
				actions: {
					edit: 'Edit',
					update: 'Update',
				},
			},
		},
		enmu: {
			status: {
				draft: 'Draft',
				published: 'Published',
			},
			type: {
				durable: 'Durable',
				consumable: 'Consumable',
			},
		},
		modal: {
			title: 'Create a DLC',
			error: {
				nonuniqueSKU: '"{{name}}" already exists. Try again with a unique SKU.',
			},
			success: {
				message: 'You successfully initialze a DLC.',
				description: 'You successfully initialze a DLC.',
			},
		},
	},
	downloadableContentEdit: {
		message: {
			update: {
				success: {
					title: 'You successfully update the DLC.',
					description: 'You successfully update the DLC.',
				},
			},
			upload: {
				success: {
					title: 'You successfully upload a file.',
					description: 'You successfully upload a file.',
				},
			},
			submit: {
				success: {
					title: 'You successfully submit the dlc.',
					description: 'You successfully submit the dlc.',
				},
				failure: {
					title: 'Missing Required Information',
					description: 'Please fill in all the required fields before submitting.',
				},
			},
		},
		summary: {
			createdAt: 'Created At',
			lastUpdatedAt: 'Last Updated At',
			submittedAt: 'Submitted At',
		},
		tabs: {
			description: {
				title: 'Description',
				description: 'Fill out the fields below. This information will be displayed in the store and library.',
				form: {
					name: {
						title: 'Name',
					},
					brief: {
						title: 'Brief',
						description: 'The brief introduction of this DLC can be viewed on the details page of the store.',
					},
					description: {
						title: 'Description',
						description: 'The description of this DLC can be viewed on the details page of the store.',
					},
				},
			},
			dlcFile: {
				title: 'DLC Files',
				description:
					'Downloadable content (DLC) refers to additional content or files that can be downloaded, such as game expansion packs.',
				form: {
					uploadDLCFile: {
						title: 'Upload DLC Files',
						description: 'The maximum file size is 4Gb',
						minimumCompatibleVersion: 'Minimum Compatible Version (Global)',
						contactUs: 'If you need more space, contact us at ',
						unique: 'The file with name "{{fileName}}" already exists in the project.',
					},
					minimumCompatibleVerison: {
						title: 'Minimum Compatible Version',
					},
				},
			},
			assets: {
				title: 'Assets',
				description:
					'Images and videos can be viewed in omni Store. You can complete the basic descriptions of the assets below.',
				form: {
					icon: {
						title: 'Icon',
						description:
							'Use icons to help users recognize your DLC. The icons can be viewed in places such as stores and application lists.',
						hint: '1:1 - 512x512px (png, jpeg, 2MB max)',
					},
					coverArt: {
						title: 'Cover Art',
						description: 'Use posters to show users the core display effect of your DLC. The posters can be viewed in Store.',
						hint: '16:9 - 640x360px (png, jpeg, 2MB max)',
					},
					detailImages: {
						title: 'Detail Images(4-7 Images)',
						subTitle: 'Detail Image {{detailImageNum}}',
						description:
							'Use four to seven detail images to show users the core scenarios and highspots of your DLC. The images can be viewed in Store.',
						optional: '(optional)',
						hint: '16:9 - 1280x720px (png, jpeg, 2MB max)',
						detailImage1: 'Detail Image 1',
						detailImage2: 'Detail Image 2',
						detailImage3: 'Detail Image 3',
						detailImage4: 'Detail Image 4',
						video: 'Video',
					},
					video: {
						title: 'Videos',
						description:
							'Use videos to show users your DLC. A maximum of three videos can be viewed on the application details page and covers must be configured for the videos.',
						subTitle1: 'MP4',
						subTitle2: 'Video Screenshot',
						hint1: '16:9 - 1280x720px (100 MB Max Size)',
						hint2: '16:9 - 1280x720px (png, jpeg, 2MB max)',
						videoScreenShot: 'Video Screenshot',
					},
				},
				error: {
					video: 'Video',
				},
			},
			contentRating: {
				title: 'Content Rating',
				description:
					'The DLC content rating (IARC) should be the same as the rating of the base application serving this DLC. If this DLC affects the application rating, please update the rating information for that application first. ',
				form: {
					checkbox: {
						description: 'I confirm that this DLC does not affect the rating of the application.',
						error: 'You need to confirm it',
					},
				},
			},
			pricing: {
				title: 'Pricing',
				description:
					'Omni Online uses a tiered price system to manage prices in different regions. You can select a price suitable for your DLC.',
				form: {
					price: {
						title: 'Price',
					},
					checkbox: {
						description:
							'I confirm that the price of this DLC published on the Omni One is not higher than other platforms in the same region',
						error: 'You need to confirm it',
					},
				},
			},
		},
	},
	leaderboardsPage: {
		header: 'Leaderboards',
		create: 'Create a Leaderboard',
		apiName: 'API Name',
		title: 'Title',
		gameStat: 'Game Stat',
		sortOrder: 'Sort Order',
		sortBy: 'Sort By',
		scoreType: 'Type of Sorting Field',
		isPublic: 'Whether to enable friend leaderboard',
		enableSurpassedNotification: 'Whether to enable notification',
		yes: 'Yes',
		no: 'No',
		resetFrequency: 'Reset Frequency',
		actions: 'Actions',
		noLeaderboards: {
			line1: 'Your project does not have any leaderboards yet.',
			line2: 'Enable leaderboards by clicking the “Create a Leaderboard” button.',
		},
		leaderboardSortOrder: {
			highestIsLeader: 'Highest is leader',
			lowestIsLeader: 'Lowest is leader',
		},
		delete: 'Delete Leaderboard',
		edit: 'Edit Leaderboard',
		deleteMessage: 'Leaderboard Deleted',
		deleteDescription: 'You successfully deleted {{apiName}}.',
		deleteModal: {
			header: 'Delete Leaderboard',
			okButton: 'Yes, Delete',
			body: 'Are you sure you want to delete {{apiName}}?',
		},
	},
	createLeaderboardV2Page: {
		apiName: {
			label: 'API Name',
			placeholder: 'API name of the Leaderboard',
			hint: 'The unique identifier of the leaderboard that is used within the project code.',
			alreadyTaken: '"{{name}}" already exists. Try again with a unique name.',
		},
	},
	createLeaderboardPage: {
		header: 'Create a Leaderboard',
		editHeader: 'Edit Leaderboards',
		apiName: {
			label: 'API Name',
			placeholder: 'API name of the Leaderboard',
			hint: 'The name of the leaderboard that is used within the project code.',
			hintV2: 'The unique identifier of the leaderboard that is used within the project code.',
			alreadyTaken: '"{{name}}" already exists. Try again with a unique name.',
		},
		create: 'Create Leaderboard',
		title: {
			label: 'Title',
			placeholder: 'Title of the Leaderboard',
			hint: 'The name of the leaderboard that the player sees.',
		},
		gameStat: {
			label: 'Game Stat',
			placeholder: 'Game stat of the Leaderboard',
			hint: 'The game stat used to build the leaderboard',
		},
		sortOrderV2: {
			label: 'Sort By',
			hint: 'Defines the order of how the leaderboard entries are arranged.',
			sortOrderEnum: {
				higherIsBetter: 'High to Low',
				lowerIsBetter: 'Low to High',
			},
		},
		sortOrder: {
			label: 'Sort Order',
			hint: 'Order of leaderboard - highest first or lowest first',
			sortOrderEnum: {
				lowestFirst: 'Lowest First',
				highestFirst: 'Highest First',
			},
		},
		scoreType: {
			label: 'Sort Type',
			hint: 'Defines by what unit of measurement the leaderboard entries are arranged:',
			scoreTypeEnum: {
				point: 'Score',
				timeInMillisecond: 'Time (milliseconds)',
				timeInSecond: 'Time (seconds)',
				distanceInMeters: 'Distance (meters)',
				distanceInFoot: 'Distance (feet)',
				percentage: 'Percentage',
			},
		},
		entryWritePolicy: {
			label: 'Data Write Permission',
			hint: 'Defines who is allowed to write entries to the leaderboard:',
			entryWritePolicyEnum: {
				clientAuthoritative: 'Client Authoritative',
				serverAuthoritative: 'Server Authoritative',
			},
		},
		isPublic: {
			label: 'Whether to enable friend leaderboard',
			hint: 'If it is enabled, users of this app can view the rankings of themselves and their friends on the leaderboard.',
		},
		enableSurpassedNotification: {
			label: 'Whether to enable notification',
			hint: 'If it is enabled, users on the leaderboard will receive a notification when their friends overtake them, provided that they must also enable friend leaderboard.',
		},
		resetFrequency: {
			label: 'Reset Frequency',
			hint: 'How often the board data resets',
			resetFrequencyEnum: {
				daily: 'Daily',
				weekly: 'Weekly',
				monthly: 'Monthly',
				yearly: 'Yearly',
				never: 'Never',
			},
		},
		resetHour: {
			label: 'Reset Time',
			hint: 'What time the board data resets',
		},
		form: {
			api_name: {
				placeholder: 'Game Stat',
			},
		},
		notification: {
			update: {
				message: 'Leaderboard Changed',
				description: 'You successfully edited {{title}}.',
			},
			create: {
				message: 'You successfully created a Leaderboard.',
				description: '"{{title}}" has been added to Leaderboards.',
			},
			error: {
				message: 'Failed to create a Leaderboard.',
				description: 'The server rejected creating the Leaderboard for an unknown reason.',
			},
		},
	},
	createGameStatsPage: {
		header: 'Create a Game Stat',
		apiName: {
			label: 'API Name',
			placeholder: 'API name of the Stat',
			hint: 'The name of the stat that is used within the project code.',
			alreadyTaken: '"{{name}}" already exists. Try again with a unique name.',
		},
		create: 'Create Game Stat',
		title: {
			label: 'Title',
			placeholder: 'Title of the Stat',
			hint: 'The name of the stat that the player sees.',
		},
		format: {
			label: 'Format',
			hint: 'Format of the stat',
			gameStatFormatEnum: {
				integer: 'Integer (##)',
				decimal: 'Decimal (#.#)',
				percentage: 'Percentage (%)',
				hourMinutesSeconds: 'Hours Minutes Seconds (HH:MM:SS)',
				daysHoursMinutes: 'Days Hours Minutes (DD:HH:MM)',
			},
		},
		unitOfMeasurement: {
			label: 'Unit Of Measurement',
			hint: 'Unit Of Measurement of the stat',
			unitOfMeasurementEnum: {
				inches: 'Inches',
				feet: 'Feet',
				miles: 'Miles',
				centimeters: 'Centimeters',
				meters: 'Meters',
				kilometers: 'Kilometers',
				milliseconds: 'Milliseconds',
				seconds: 'Seconds',
				minutes: 'Minutes',
				hours: 'Hours',
				days: 'Days',
				numbers: 'Numbers (Count or Points)',
			},
		},
		serverOnly: {
			label: 'Server Only',
			hint: 'This stat can only be updated by a game server',
		},
		notification: {
			success: {
				message: 'You successfully created a game stat.',
				description: '"{{title}}" has been added to Game Stats.',
			},
			error: {
				message: 'Failed to create the game stat.',
				description: 'The server rejected the game stat for an unknown reason.',
			},
		},
	},
	editGameStatsPage: {
		header: 'Edit Game stats',
		apiName: {
			label: 'API Name',
			placeholder: 'API name of the Stat',
			hint: 'The name of the stat that is used within the project code.',
			alreadyTaken: '"{{name}}" already exists. Try again with a unique name.',
		},
		update: 'Save Changes',
		title: {
			label: 'Title',
			placeholder: 'Title of the Stat',
			hint: 'The name of the stat that the player sees.',
		},
		format: {
			label: 'Format',
			hint: 'Format of the stat',
			gameStatFormatEnum: {
				integer: 'Integer (##)',
				decimal: 'Decimal (#.#)',
				percentage: 'Percentage (%)',
				hourMinutesSeconds: 'Hours Minutes Seconds (HH:MM:SS)',
				daysHoursMinutes: 'Days Hours Minutes (DD:HH:MM)',
			},
		},
		unitOfMeasurement: {
			label: 'Unit Of Measurement',
			hint: 'Unit Of Measurement of the stat',
			unitOfMeasurementEnum: {
				inches: 'Inches',
				feet: 'Feet',
				miles: 'Miles',
				centimeters: 'Centimeters',
				meters: 'Meters',
				kilometers: 'Kilometers',
				milliseconds: 'Milliseconds',
				seconds: 'Seconds',
				minutes: 'Minutes',
				hours: 'Hours',
				days: 'Days',
				numbers: 'Numbers (Count or Points)',
			},
		},
		notification: {
			success: {
				message: 'Game Stat Updated',
				description: 'You successfully updated the Game Stat.',
			},
			error: {
				message: 'Failed to update the game stat.',
				description: 'The server rejected the game stat for an unknown reason.',
			},
		},
	},
	achievementsPage: {
		Header: 'Achievements',
		Create: 'Create an Achievement',
		NoAchievement:
			'Your project does not have any achievements yet.<br/>Enable achievements by clicking the “Create an Achievement” button.',
		Secret: 'Yes',
		NotSecret: 'No',
		actions: {
			edit: 'Edit Achievement',
			delete: 'Delete Achievement',
			deleteMessage: 'Achievement Deleted',
			deleteDescription: 'You successfully deleted {{apiName}}.',
			deleteModal: {
				header: 'Delete Achievement',
				okButton: 'Yes, Delete',
				body: 'Are you sure you want to delete {{apiName}}?',
			},
		},
	},
	createAchievementPage: {
		header: 'Create an Achievement',
		name: {
			label: 'API Name',
			placeholder: 'API name of the achievement',
			hint: 'The name of the achievement that is used within the project code.',
		},
		title: {
			label: 'Title',
			placeholder: 'Displayed name of the achievement',
			hint: 'The name of the achievement that the player sees.',
		},
		description: {
			label: 'Description',
			placeholder: 'Description of the achievement',
			hint: 'Description of the achievement that the player sees. For example, provide guidance as to how to earn the achievement.',
		},
		unlockedDescription: {
			label: 'Unlocked Description (Optional)',
			placeholder: 'Description of the achievement once unlocked',
			hint: 'An optional replacement description that’s only revealed once the player attains the achievement. For example, you may want to hide spoilers about how the acheivement is accomplished.',
		},
		unlockedIcon: {
			label: 'Unlocked Icon (Optional)',
			aspectRatio: 'Aspect Ratio: 1:1',
			hint: '256x256px',
		},
		lockedIcon: {
			label: 'Locked Icon (Optional)',
			aspectRatio: 'Aspect Ratio: 1:1',
			hint: '256x256px',
		},
		type: {
			label: 'Type',
			hint: 'Determines how the achievement is unlocked.',
			achievementTypeEnum: {
				Simple: 'Simple',
				Count: 'Count',
				BitField: 'BitField',
			},
			target: {
				label: 'Target',
				placeholder: 'Unlock Target',
				hint: 'Target Number to unlock achievement',
			},
			bitfieldLength: {
				label: 'Length',
				placeholder: 'Max number',
				hint: 'The max number of bits',
			},
		},
		isSecret: {
			label: 'Is Achievement Secret?',
			hint: 'This is an achievement that the player cannot see before it has been earned.',
		},
		serverOnly: {
			label: 'Server Only',
			hint: 'This stat can only be updated by a game server',
		},
		notification: {
			success: {
				message: 'You successfully created an achievement.',
				description: '"{{title}}" has been added to Achievements.',
			},
			error: {
				message: 'Failed to create the achievement.',
				description: 'The server rejected the achievement for an unknown reason',
			},
			uploadLockedIconSuccess: {
				message: 'You successfully uploaded a locked icon.',
				description: 'The icon has been added to the achievement.',
			},
			uploadUnlockedIconSuccess: {
				message: 'You successfully uploaded an unlocked icon.',
				description: 'The icon has been added to the achievement.',
			},
		},
		createAchievement: 'Create an Achievement',
	},
	editAchievementPage: {
		header: 'Edit an Achievement',
		editHeader: 'Edit Achievements',
		notification: {
			update: {
				message: 'Achievement Changed',
				description: 'You successfully edited {{title}}.',
			},
		},
	},
	'accessDeniedPage.Header': 'Access Denied',
	'accessDeniedPage.Body': 'An administrator has blocked your account.',
	'redemptionCodesPage.Header': 'Redemption Codes',
	'redemptionCodesPage.Header.Create': 'Create a Code',
	'redemptionCodesPage.Header.ExportAsCSV': 'Download as CSV',
	'redemptionCodesPage.Header.Delete': 'Delete',
	'redemptionCodesPage.None.Line1': 'Your project does not have any redemption codes yet.',
	'redemptionCodesPage.None.Line2': 'Start generating redemption codes by clicking the "Create a Code" button.',
	'redemptionCodesPage.NotReady.Line1': 'Your project does not have any redemption codes yet.',
	'redemptionCodesPage.NotReady.Line2': 'You must first release your project.',
	'redemptionCodesPage.NoAccess.Line1': 'You cannot generate redemption codes yet.',
	'redemptionCodesPage.NoAccess.Line2':
		'1. Reach out to your project administrator to issue access to the Redemption Codes page.',
	'redemptionCodesPage.NoAccess.Line3': '2. Return to this page to generate redemption codes for your project.',
	'redemptionCodesPage.Table.Code': 'Redemption Code',
	'redemptionCodesPage.Table.Created': 'Created',
	'redemptionCodesPage.Table.CreatedBy': 'Created By',
	'redemptionCodesPage.Table.Redeemed': 'Redeemed At',
	'redemptionCodesPage.Table.Player': 'Player',
	'redemptionCodesPage.Table.Delete': 'Delete',
	'redemptionCodePage.GenerateModal.Header': 'Invite Test Users',
	'redemptionCodePage.GenerateModal.Email': 'Test User Email Address(es)',
	'redemptionCodePage.GenerateModal.Email.hint': 'Split emails with commas or spaces',
	'redemptionCodePage.GenerateModal.OkButton': 'Send Invitation',
	'redemptionCodePage.GenerateModal.Success.Header': 'You successfully invited {{emails}} test users.',
	'redemptionCodePage.GenerateModal.Success.Body': 'Invitation was sent to {{emails}} test users.',
	'redemptionCodePage.GenerateModal.Info.Header': 'Invitations were not sent to {{count}} users.',
	'redemptionCodePage.GenerateModal.Info.Body': 'These users already exist as test users: {{usersList}}',
	'redemptionCodesPage.DeleteRedemptionCodeModal.Header': 'Delete Redemption Code',
	'redemptionCodesPage.DeleteRedemptionCodeModal.OkButton': 'Yes, Delete',
	'redemptionCodesPage.DeleteRedemptionCodeModal.Body': 'Are you sure you want to delete {{num}} redemption code(s)?',
	'redemptionCodesPage.DeleteRedemptionCodeModal.Success.Header': 'Redemption Codes Deleted',
	'redemptionCodesPage.DeleteRedemptionCodeModal.Success.Body': 'You deleted {{count}} redemption code.',
	'redemptionCodesPage.DeleteRedemptionCodeModal.Success.Body_plural': 'You deleted {{count}} redemption codes.',
	'redemptionCodesPage.CreateRedemptionCodeModal.Header': 'Create a Code',
	'redemptionCodesPage.CreateRedemptionCodeModal.OkButton': 'Generate Codes',
	'redemptionCodesPage.CreateRedemptionCodeModal.Success.Header': 'Redemption Codes Created',
	'redemptionCodesPage.CreateRedemptionCodeModal.Success.Body': 'You generated {{num}} redemption codes.',
	'redemptionCodesPage.CreateRedemptionCodeModal.Count': 'Count',
	'redemptionCodesPage.CreateRedemptionCodeModal.CountValidation.Max':
		'You can only generate a maximum of {{num}} redemption codes.',
	'redemptionCodesPage.CreateRedemptionCodeModal.CountValidation.Min': 'Enter a number that is greater than or equal to 1.',
	'redemptionCodesPage.CreateRedemptionCodeModal.CountValidation.Required': 'Count is a required field.',
	'redemptionCodesPage.CreateRedemptionCodeModal.Count.hint': 'How many codes do you want to create?',
	redemptionCodesPage: {
		type: {
			redemptionCode: 'Redemption Codes',
			minimumGuaranteedCode: 'MG Codes',
		},
		noData: {
			description: {
				minimumGuaranteedCode: {
					line1: 'There are no minimum guaranteed codes.',
				},
			},
		},
		tooltipForDisabledDeleteButton: 'Cannot delete code since this code has already been used.',
	},
	publishingRequirementsPage: {
		header: 'Publishing Requirements',
		completed: '{{progress}}% Completed',
		save: 'Save Progress',
		category: {
			Security: 'Security',
			PlayerMovement: 'Player Movement',
			OnlineFeatures: 'Online Features',
			MultiplayerFeatures: 'Multiplayer Features',
			Performance: 'Performance',
			VRInputFunctionality: 'VR Input Functionality',
			PublishingRequirements: 'Publishing Requirements',
		},
		prefix: {
			SdkVersion: 'SDK Version',
			VOIP: 'VOIP',
			Multiplayer: 'Multiplayer',
			Leaderboards: 'Leaderboards',
			OmniMovement: 'Omni Movement',
			Entitlement: 'Entitlement',
			Permissions: 'Permissions',
			Recentering: 'Recentering',
			Settings: 'Settings',
			Tutorial: 'Tutorial',
		},
		item: {
			OmniEntitlementCheck:
				'The application must be configured to perform the Omni entitlement check when launched. Other platforms’ entitlement checks must be disabled.',
			EssentialPermissions: 'The application must only request the essential permissions necessary for its functionality.',
			NoAutoRecentering:
				'The application must not automatically recenter when loading new levels or at any time after launch, except for manual recentering by long pressing the home button.',
			MovementSpeed:
				"The application must ensure that the player's movement speed is appropriate for the virtual environment, with smaller environments requiring a lower speed setting than larger ones.",
			AllowMovement:
				'The application must allow the player to move forward, backward, left, and right (strafe) using Omni input.',
			VariableSpeed:
				'The application must allow the player to move with variable speed, ensuring that movement speed in the application increases proportionally with the player’s speed on the Omni.',
			PreventInputExploit:
				'The application must prevent the player from exploiting movement by using multiple inputs, such as the joystick and Omni simultaneously, to move at an unintended faster speed.',
			NoMomentumSmoothing:
				'The application must not allow for momentum in movement or add additional smoothing to Omni movement, as this can create the perception of input lag from the Omni.',
			IncludeAllInputs:
				'The application must include all movement inputs (joystick or teleportation) and play-boundary modes (sitting, standing, room-scale), that are available on other platforms.',
			NoActionsBeyondOmni:
				'The application must not require the player to perform actions beyond the limits of the Omni to progress. If such actions are necessary, controller input must be provided, and the controls should be clearly explained to avoid unsafe attempts by players.',
			ConsistentMovement:
				'The application must ensure consistent movement across the Omni and other input methods. If a sprint button is used with the controller, it should also function when the player is using the Omni.',
			SprintButtonConsistency:
				'The sprint button, if present, should behave consistently when using the Omni as with any other input method.',
			IncludeInTutorial:
				'The application must include information for all movement modes (including Omni movement) and controls in the tutorial if one exists.',
			NotifyInternetRequirement:
				"The application must notify users that an internet connection is required if they do not have an active connection and the app's core functionality depends on it.",
			DisableMultiplayerSubscription:
				'The application must disable multiplayer, player invites, and posting of scores to leaderboards if the player is not subscribed to Omni Online and display a message that Omni Online is required for such functionality.',
			ScorePosting:
				'The application must allow players to post their scores and see them reflected on the in-application leaderboard display if leaderboards are utilized.',
			AchievementsUnlocking:
				'The application must allow players to unlock Achievements by completing corresponding actions if Achievements are utilized.',
			InviteWindowIntegration:
				"The application must integrate the platform's 'Invite Window' using the appropriate SDK function call if it includes a player invitation method for multiplayer sessions.",
			DisableVoiceChatParty: 'The application must disable in-application voice chat for a player in an Omni One party.',
			DisableInAppVoiceChatWhenJoiningParty:
				'The application must disable in-application voice chat when a player joins a party while the application is running.',
			EnableVoiceChatLeaving:
				'The application must enable in-application voice chat when a player leaves a party while the application is running.',
			VOIPAudioLevel: 'The application must ensure that the audio does not overpower the VOIP audio level.',
			Maintain72FPS: 'The application must maintain a minimum of 72 frames per second on the Omni One headset.',
			StablePerformance:
				'The application must maintain stable performance, avoiding any crashes, freezes, or significant periods of unresponsiveness.',
			HeadTrackedVisuals:
				'The application must display head-tracked visuals within 5 seconds of startup or provide a loading indicator in the VR environment.',
			SleepModeFunctionality:
				'The application must maintain proper functionality if the player removes the headset, allows it to enter sleep mode, and then resumes use.',
			PositionalTrackingResponse:
				"The application must respond to both the headset's positional tracking and orientation changes.",
			HandPositionAlignment:
				'The application must ensure that in-application hands and controllers closely match the position and orientation of the user’s real-world counterparts.',
			HomeButtonFunctionality:
				'The application must not interfere with the Home button on the controller, allowing it to perform its default system functions: a short press activates the Omni menu, and a long press recenters and calibrates the headset.',
			InputButtonActions:
				'The application must correctly display the actions for each input button if a controls image is provided.',
			MenuButtonTrigger:
				'The application should trigger the in-application menu, if available, using the menu button on the controller.',
			ValidWebLinks: 'The application must link directly to valid web pages if any website URLs are present.',
			VirtuixBrandCompliance: 'The application must comply with Virtuix brand guidelines whenever the Virtuix brand is used.',
			PublicAppropriateStoreDetails:
				'The application must include store details and assets that are appropriate for public viewing.',
			CoverAssetsClearLogo:
				'The application must include ‘Cover Assets’ with the application logo clearly visible and readable.',
		},
		saveSuccess: {
			message: 'Progress Saved',
			description: 'You successfully saved your progress on completing the Publishing Requirements.',
		},
		completeSuccess: {
			message: 'Publishing Requirements Completed',
			description: 'You successfully completed the Publishing Requirements.',
		},
	},
	// pages

	// Genre enum
	'Genre.ActionAndAdventure': 'Action & adventure',
	'Genre.CardAndBoard': 'Card & board',
	'Genre.Casino': 'Casino',
	'Genre.Classics': 'Classics',
	'Genre.Educational': 'Educational',
	'Genre.FamilyAndKids': 'Family & kids',
	'Genre.Fighting': 'Fighting',
	'Genre.Horror': 'Horror',
	'Genre.MultiplayerOnlineBattleArena': 'Multiplayer online battle arena',
	'Genre.Music': 'Music',
	'Genre.Other': 'Other',
	'Genre.Platformer': 'Platformer',
	'Genre.PuzzleAndTrivia': 'Puzzle & trivia',
	'Genre.RacingAndFlying': 'Racing & flying',
	'Genre.RolePlaying': 'Role playing',
	'Genre.Shooter': 'Shooter',
	'Genre.Simulation': 'Simulation',
	'Genre.Social': 'Social',
	'Genre.Sports': 'Sports',
	'Genre.Strategy': 'Strategy',
	//Genre enum

	// AgeRating enum
	'AgeRating.Everyone': 'Everyone',
	'AgeRating.Everyone10Plus': 'Everyone 10+',
	'AgeRating.Teen': 'Teen',
	'AgeRating.Mature17Plus': 'Mature 17+',
	// AgeRating enum

	// CollaboratorPermission enum
	'Collaborators.All': 'All (Project Administrator)',
	'Collaborators.Collaborators': 'Collaborators',
	'Collaborators.StoreDetails': 'Store Details',
	'Collaborators.Builds': 'Builds',
	'Collaborators.GameServices': 'Game Services',
	'Collaborators.Finances': 'Finances',
	'Collaborators.Players': 'Players',
	'Collaborators.Analytics': 'Analytics',
	'Collaborators.RedemptionCodes': 'Redemption Codes',
	// CollaboratorPermission enum

	// TestUser enum
	'TestUserStatus.Pending': 'Invitation Pending',
	'TestUserStatus.Joined': 'Joined',
	// TestUser enum

	// MovementIntensity enum
	'MovementIntensity.Low': 'Low',
	'MovementIntensity.Moderate': 'Moderate',
	'MovementIntensity.Intense': 'High',
	// MovementIntensity enum

	// Language enum
	'Language.English': 'English',
	// Language enum
};

export default translation;
